<template>
  <div class="experience">
    <div class="experience-warp">
      <h1 class="play-title">试玩</h1>
      <ul class="list"  v-lazy-container="{ selector: 'img', loading: '//txwl.huohuoche.com/mobileTXW_3.0/exhibition/waterLoading.gif' }">
        <li v-for="(item, key) in experienceList" :key="key" @click="jump(item)">
          <img :data-src="item.img" alt />
          <p>{{item.title}}</p>
        </li>
      </ul>
      <div class="bottom-content">
        <h2 class="other-title">其他试玩</h2>
        <ul class="other-list">
          <li v-for="(item, key) in otherPlayList" :key="key" @click="jump(item)">
            <img :src="item.img" alt />
            <p>{{item.title}}</p>
          </li>
        </ul>
      </div>
      <footer-copy></footer-copy>
    </div>
  </div>
</template>
<script>
export default {
  name: "experience",
  data() {
    return {
      experienceList: [
        {
          title: '综合APP',
          img: "//txwl.huohuoche.com/mobileTXW_3.0/others/experience/txdemo_mobile_001.png",
          playUrl: 'https://www.load-code.com/2code_php/jump.html?id=267'
          },
        {
          title: '棋牌APP',
          img: "//txwl.huohuoche.com/mobileTXW_3.0/others/experience/txdemo_mobile_002.png",
          playUrl: ''
          },
        {
          title: '电竞APP',
          img: "//txwl.huohuoche.com/mobileTXW_3.0/others/experience/txdemo_mobile_003.png",
          playUrl: ''
          },
        {
          title: '彩票APP',
          img: "//txwl.huohuoche.com/mobileTXW_3.0/others/experience/txdemo_mobile_004.png",
          playUrl: ''
          },
        {
          title: '综合APP',
          img: "//txwl.huohuoche.com/mobileTXW_3.0/others/experience/txdemo_chess_001.png",
          playUrl: ''
          },
        {
          title: '棋牌APP',
          img: "//txwl.huohuoche.com/mobileTXW_3.0/others/experience/txdemo_chess_002.png",
          playUrl: ''
          }
      ],
      otherPlayList: [
        { title: '大唐棋牌', img: "//txwl.huohuoche.com/mobileTXW_3.0/others/dt-logo.png", playUrl: 'https://play.xtqnr.com' },
        { title: '金蟾捕鱼', img: "//txwl.huohuoche.com/mobileTXW_3.0/others/jc-fish.png", playUrl: ''  },
        { title: '天下汇视讯', img: "//txwl.huohuoche.com/mobileTXW_3.0/others/txh-logo.png", playUrl: 'http://m-tryplay.txh-demo.com'  }
      ]
    };
  },
  mounted() {
    this.utils.animateCSS( ".experience-warp .play-title", ["animate__rotateInDownLeft"]);
    this.utils.animateCSS( ".experience-warp .list", ["animate__fadeInRight", "animate__delay-decimal4s"]);
    this.utils.animateCSS( ".experience-warp .bottom-content", ["animate__backInUp", "animate__delay-decimal4s"]);
  },
  methods: {
    jump(item) {
      if (item.playUrl === '') return;
      window.location.href = item.playUrl;
    }
  }
};
</script>
<style lang="less" scoped>
.experience {
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
  .experience-warp {
    min-height: 100%;
    padding: 0 45px;
    background: url("//txwl.huohuoche.com/mobileTXW_3.0/others/bg1.jpg")
      no-repeat;
    background-position: top center;
    background-size: cover;
    h1.play-title {
      font-size: 90px;
      font-weight: bold;
      padding: 60px 0;
    }
    ul.list {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      li {
        width: 498px;
        height: auto;
        margin: 0 30px 30px 0;
        &:nth-child(2n) {
          margin-right: 0;
        }
        img {
          display: block;
          width: 100%;
          height: auto;
        }
        p {
          height: 80px;
          text-align: center;
          line-height: 80px;
          font-size: 38px;
          background: rgba(16, 14, 56, 0.9);
        }
      }
    }
    h2.other-title {
      font-size: 42px;
      font-weight: bold;
      padding: 40px 0 60px;
    }
    ul.other-list {
      display: flex;
      justify-content: space-between;
      padding-bottom: 40px;
      li {
        width: 268px;
        height: 368px;
        img {
          display: block;
          width: 268px;
          height: 268px;
          background: #13123A;
          border-radius: 50%;
        }
        p {
          height: 100px;
          text-align: center;
          line-height: 100px;
          font-size: 38px;
        }
      }
    }
  }
}
</style>
